module.exports = __webpack_public_path__ + "static/media/fb_3l.48e5c48f.png";